/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { URI } from '../models/URI';
import { HttpFile } from '../http/http';

export class HorseProfilePhoto {
    'name'?: string;
    'image': URI;
    'thumbnail': URI;
    'inProfile'?: boolean;
    'isSalePhoto'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "image",
            "baseName": "image",
            "type": "URI",
            "format": "uri"
        },
        {
            "name": "thumbnail",
            "baseName": "thumbnail",
            "type": "URI",
            "format": "uri"
        },
        {
            "name": "inProfile",
            "baseName": "inProfile",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "isSalePhoto",
            "baseName": "isSalePhoto",
            "type": "boolean",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return HorseProfilePhoto.attributeTypeMap;
    }

    public constructor() {
    }
}

